import React from "react";
import { Button } from "../ButtonElements";
import { motion } from "framer-motion";
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  TextWrapper,
  TopLine,
  Heading,
  SubTitle,
  BtnWrap,
  Column2,
  Img,
  ImgWrap,
} from "./InfoSectionElements";
import { Socials } from "../Socials/Socials";

// Motion variants
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const slideInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

function InfoSection({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headLine,
  darkText,
  buttonLabel,
  img,
  alt,
  primary,
  dark,
  dark2,
  description,
}) {
  return (
    <InfoContainer lightBg={lightBg} id={id}>
      <InfoWrapper>
        <InfoRow imgStart={imgStart}>
          <Column1>
            <TextWrapper>
              <TopLine
                as={motion.div}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
                custom={0}
              >
                {topLine}
              </TopLine>
              <Heading
                lightText={lightText}
                as={motion.h2}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
                custom={0.2}
              >
                {headLine}
              </Heading>
              <SubTitle
                darkText={darkText}
                as={motion.p}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
                custom={0.4}
              >
                {description}
              </SubTitle>
              <Socials />
              <BtnWrap
                as={motion.div}
                initial="hidden"
                animate="visible"
                variants={fadeUp}
                custom={0.6}
              >
                <Button
                  to="contact"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  primary={primary ? 1 : 0}
                  dark={dark ? 1 : 0}
                  dark2={dark2 ? 1 : 0}
                >
                  {buttonLabel}
                </Button>
              </BtnWrap>
            </TextWrapper>
          </Column1>

          <Column2>
            <ImgWrap
              as={motion.div}
              initial="hidden"
              animate="visible"
              variants={slideInRight}
            >
              <Img src={img} alt={alt} />
            </ImgWrap>
          </Column2>
        </InfoRow>
      </InfoWrapper>
    </InfoContainer>
  );
}

export default InfoSection;
